export const exists = (t) => t !== undefined;
